
import {mapState} from "vuex"

import VueDraggableResizable from 'vue-draggable-resizable-gorkys'


export default {
  name: "node",
  props: {
    page: {
      type: Array
    },
    zoom: {
      type: Number,
      default: 1
    },
    pageBg: {
      type: String
    },
    pageItemIndex: {
      type: Number,
      default: 0
    },
    realIndex: {
      type: Number,
      default: 0
    },
    x: {
      type: Number
    },
    y: {
      type: Number
    },
    activeId: {
      type: String
    }
  },

  components: {VueDraggableResizable},
  data() {
    return {}
  },
  methods: {},
  computed: {
    ...mapState({
      isActive: state => state.isActive
    })
  },
}
